var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-label"},[_vm._l((_vm.list),function(item){return [_c('router-link',{key:item.id,attrs:{"to":{path:'/sort-css/'+item.id,query:{tId:item.id,type: item.tyNum+' '+item.tyName}}}},[_vm._v(_vm._s(item.tyNum+' '+item.tyName))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a1c51c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/sort/SortCss.vue
// module id = null
// module chunks = 